import styled, { css } from 'styled-components';

export const ControlButtons = styled.div`
    width: 100%;
    display: grid;
    grid-auto-flow: column;
    gap: 5rem;
    justify-content: center;
    border-top: ${({ theme }) => `1px solid ${theme.branding.gray.light}`};
    //margin: 0 -3rem 0;
    padding: 1rem 0;
`;

export const dialogContentStyle = css`
    padding: 1rem;
`;
